module.exports = __webpack_public_path__ + "static/media/customize.1af374c5.png";